import React from "react";
import styled from "styled-components";

// Scrollable viewport for the auth pages. MainWrapper is position:fixed and
// shared with the dashboard, so the window itself doesn't scroll — this inner
// container owns the scroll. Use `margin: auto` centering (NOT justify-content)
// so that when the form is taller than the viewport the content stays reachable
// from the top instead of being clipped (the flexbox safe-center bug).
const ScrollContainer = styled.main`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    display: flex;
    flex-direction: column;
`;

const Auth = styled.div`
    width: 100%;
    margin: auto;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    padding: 24px 0;
`;

export default ({ children }) => (
    <ScrollContainer>
        <Auth>{children}</Auth>
    </ScrollContainer>
);
